import client_core from "@/services/clients/client_core";

const PicaServiceService = {
    getPicaService(picaServiceId) {
        return client_core.get(`/dashboard/v1/pica-services/${picaServiceId}/`)
    },

    updateTagStatus(picaServiceId, isTagCompleted) {
        return client_core.patch(`/dashboard/v1/pica-services/${picaServiceId}/set-tagging-completion/`, {
            is_tagging_completed: isTagCompleted
        })
    },

    updateUploadStatus(picaServiceId) {
        return client_core.patch(`/dashboard/v1/pica-services/${picaServiceId}/set-upload-completion/`, {})
    },

    getPicacodeReleased(picaServiceId, searchParams = {}) {
        let params = {}
        if ('picacode' in searchParams)
            params['picacode'] = searchParams.picacode
        if ('raceNumber' in searchParams)
            params['race_number'] = searchParams.raceNumber
        return client_core.get(`/dashboard/v1/pica-services/${picaServiceId}/picacodes-released/`, { params })
    },

    getPromoCodes(picaServiceId) {
        return client_core.get(`/dashboard/v1/pica-services/${picaServiceId}/promo-codes/`)
    },

    setPromoCodes(picaServiceId, params) {
        return client_core.put(`/dashboard/v1/pica-services/${picaServiceId}/promo-codes/`, params)
    },

    getEventNotes(params) {
        return client_core.get(`/dashboard/v1/pica-service-notes/`, {params})
    },

    createEventNote(params) {
        return client_core.post(`/dashboard/v1/pica-service-notes/`, params)
    },

    updateEventNote(params) {
        return client_core.patch(`/dashboard/v1/pica-service-notes/${params.id}/`, {
            pica_service: params.pica_service,
            text: params.text
        })
    },

    deleteEventNote(params) {
        return client_core.delete(`/dashboard/v1/pica-service-notes/${params.id}/`, {params: {
            pica_service: params.pica_service
        }})
    },

    getAutoCheckinCodes(picaServiceId) {
        return client_core.get(`/dashboard/v1/pica-services/${picaServiceId}/autocheckin-codes/`)
    },

    setAutoCheckinCodes(picaServiceId, params) {
        return client_core.put(`/dashboard/v1/pica-services/${picaServiceId}/autocheckin-codes/`, params)
    },

    getPicaServiceForDataEntry(params) {
        return client_core.get(`/dashboard/picaservice-data-entry/`, {params})
    },
    patchPicaServiceForDataEntry(id, params) {
        return client_core.patch(`/dashboard/picaservice-data-entry/${id}/`, params)
    },
}

export default PicaServiceService
